import {
  DEVICEID_LOADER_START,
  DEVICEID_LOADER_STOP,
  FETCH_DEVICES_REQUEST,
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICES_FAILURE,
  UPDATE_DEVICE_STATUS_REQUEST,
  UPDATE_DEVICE_STATUS_SUCCESS,
  UPDATE_DEVICE_STATUS_FAILURE,
  LOADER_START,
  LOADER_STOP,
  SET_TIME_REQUEST,
  GET_TIME_REQUEST,
  ERASE_LOGS_REQUEST,
  NUM_OF_LOGS_REQUEST,
  WELD_PARAMETER_DOWNLOAD_REQUEST,
  LOCATION_REQUEST,
  PASSWORD_PROTECTION_REQUEST,
  GET_DEVICE_BY_ID_REQUEST,
  GET_DEVICE_BY_ID_SUCCESS,
  GET_DEVICE_BY_ID_FAILURE,
  CLEAR_COMMAND_RESPONSE,
} from "./types";

export const startLoading = () => ({
  type: DEVICEID_LOADER_START,
});

export const stopLoading = () => ({
  type: DEVICEID_LOADER_STOP,
});

export const startLoadingtwo = () => ({
  type: LOADER_START,
});

export const stopLoadingtwo = () => ({
  type: LOADER_STOP,
});

export const fetchDevicesRequest = () => ({
  type: FETCH_DEVICES_REQUEST,
});

export const fetchDevicesSuccess = (payload) => ({
  type: FETCH_DEVICES_SUCCESS,
  payload,
});

export const fetchDevicesFailure = (error) => ({
  type: FETCH_DEVICES_FAILURE,
  error,
});

export const fetchDevices = () => ({
  type: FETCH_DEVICES_REQUEST,
});

export const updateDeviceStatusRequest = (payload) => ({
  type: UPDATE_DEVICE_STATUS_REQUEST,
  payload,
});

export const updateDeviceStatusSuccess = (payload) => ({
  type: UPDATE_DEVICE_STATUS_SUCCESS,
  payload,
});

export const updateDeviceStatusFailure = (error) => ({
  type: UPDATE_DEVICE_STATUS_FAILURE,
  error,
});

export const commCheckRequest = (payload, onSuccess) => ({
  type: "@@deviceId/COMM_CHECK_REQUEST",
  payload,
  onSuccess,
});

export const commCheckSuccess = (payload) => ({
  type: "@@deviceId/COMM_CHECK_SUCCESS",
  payload,
});

export const commCheckFailure = (error) => ({
  type: "@@deviceId/COMM_CHECK_FAILURE",
  error,
});

export const setTimeRequest = (payload, onSuccess) => ({
  type: SET_TIME_REQUEST,
  payload,
  onSuccess,
});

export const getTimeRequest = (payload, onSuccess) => ({
  type: GET_TIME_REQUEST,
  payload,
  onSuccess,
});

export const eraseLogsRequest = (payload, onSuccess) => ({
  type: ERASE_LOGS_REQUEST,
  payload,
  onSuccess,
});

export const numOfLogsRequest = (payload, onSuccess) => ({
  type: NUM_OF_LOGS_REQUEST,
  payload,
  onSuccess,
});

export const weldParameterDownloadRequest = (payload, onSuccess) => ({
  type: WELD_PARAMETER_DOWNLOAD_REQUEST,
  payload,
  onSuccess,
});

export const locationRequest = (payload, onSuccess) => ({
  type: LOCATION_REQUEST,
  payload,
  onSuccess,
});

export const passwordProtectionRequest = (payload, onSuccess) => ({
  type: PASSWORD_PROTECTION_REQUEST,
  payload,
  onSuccess,
});

export const getDeviceByIdRequest = (payload) => ({
  type: GET_DEVICE_BY_ID_REQUEST,
  payload,
});

export const getDeviceByIdSuccess = (payload) => ({
  type: GET_DEVICE_BY_ID_SUCCESS,
  payload,
});

export const getDeviceByIdFailure = (error) => ({
  type: GET_DEVICE_BY_ID_FAILURE,
  error,
});

export const clearCommandResponse = (commandType) => ({
  type: CLEAR_COMMAND_RESPONSE,
  commandType,
});

export const clearDeviceData = () => ({
  type: "@@deviceId/CLEAR_DEVICE_DATA",
});